<template>
  <ContextMenu :id="id" :items="menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";
export default {
  mixins: [ContextMenuMixin],
  computed: {
    routeParam() {
      return { asset: this.item.id };
    },
    menu() {
      return [
        {
          label: "Edit",
          action: () => {
            this.goToRoute("admin.assets.edit", this.routeParam);
          }
        },
        {
          label: "Remove",
          action: () => {
            this.doAction("remove", this.item);
          }
        },
        {
          label: "View",
          action: () => {
            this.goToUrl(this.item.url, true);
          }
        }
      ];
    }
  }
};
</script>
